import FormFieldContainer from './FormFieldContainer';
import { useFormFieldComponentResolver } from '../fieldComponentResolverContext';
import type { ElementSettingsFormField } from '../../pages/reportBuilder/elements/types';

interface GroupFieldOptions {
    name: string;
    settings: GroupFieldSettings;
}

interface GroupFieldSettings {
    fields: readonly ElementSettingsFormField[];
    columns?: 1 | 2 | 4;
    readOnly?: boolean;
}

export default function GroupField({
    fieldOptions,
}: {
    fieldOptions: GroupFieldOptions;
}): JSX.Element {
    const { name, settings: groupSettings } = fieldOptions;
    const resolveFieldComponent = useFormFieldComponentResolver();

    return (
        <FormFieldContainer fieldOptions={fieldOptions} showOverrideCheckbox={false} inline={false}>
            <div
                className={
                    {
                        1: 'flex flex-col gap-2.5',
                        2: 'grid grid-cols-2 gap-2.5 [&>li]:!w-full',
                        4: 'grid grid-cols-4 gap-2.5 [&>li]:!w-full',
                    }[groupSettings.columns ?? 1]
                }
            >
                {groupSettings.fields.map((nestedField) => {
                    const nestedName = `${name}.${nestedField.name}`;
                    const FieldComponent = resolveFieldComponent(
                        nestedField.type,
                        nestedField.name
                    );

                    return (
                        <FieldComponent
                            key={nestedName}
                            fieldOptions={{
                                name: nestedName,
                                settings: {
                                    ...nestedField,
                                    readOnly:
                                        groupSettings.readOnly === true ||
                                        nestedField.readOnly === true,
                                },
                            }}
                        />
                    );
                })}
            </div>
        </FormFieldContainer>
    );
}
